import React from 'react';
import {useModuleList} from "../../../common/API/hooks";
import {DASHBOARD_GROUPS} from "../../../Constants/customDashboards";
import {useSave} from "../utils";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import handleError from "../ErrorHandling";
import {MANAGEMENT_MODULES} from "../constants";


const extractAndCleanPathFromContent = (content) => {
    return content.path.split('?')[0].trim().replace(/^\/+|\/+$/g, '')  // remove trailing slashes and empty spaces
}


export default function UnregisteredModules() {
    const {data: moduleList, isLoading: moduleLoading} = useModuleList();
    const {saveData: saveModule} = useSave()

    const dashboardPaths = DASHBOARD_GROUPS.flatMap(dashboardGroup => {
        return dashboardGroup.contents.filter(content => {
            return !!content.path
        }).map(extractAndCleanPathFromContent)
    }).reduce((acc, val) => {
        if (!acc.includes(val)) {
            acc.push(val)
        }
        return acc
    }, [])

    const adminPaths = Object.values(MANAGEMENT_MODULES).map(extractAndCleanPathFromContent)

    const hasDashboardPaths = !!dashboardPaths && dashboardPaths.length > 0
    const hasAdminPaths = !!adminPaths && adminPaths.length > 0

    if (!moduleList || (!hasAdminPaths && !hasDashboardPaths)) {
        return null
    }

    const registeredPaths = moduleList.map(row => row.name)
    const unregisteredDashboards = dashboardPaths.filter(path => !registeredPaths.includes(path))
    const unregisteredManagementModules = adminPaths.filter(path => !registeredPaths.includes(path))

    return <>
        The following dashboards are detected but are not yet in the module list.

        <ul>
            {
                [...unregisteredDashboards, ...unregisteredManagementModules].map(path => {
                    return <li key={path}>
                        {path}
                        <Button onClick={() => {
                            saveModule('module', {name: path}).then(() => {
                                return toast.success(`Module "${path}" saved!`);
                            }).catch(error => {
                                console.error(error);
                                const errorMessage = handleError(error, "Module", "save");
                                return toast.error(errorMessage);
                            });
                        }}>REGISTER</Button>
                    </li>
                })
            }

        </ul>
    </>
}